import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { useModalities } from '../../context/ModalitiesContext'

import Input from '../common/Input'
import ButtonPrimaryForm from '../common/ButtonPrimaryForm'
import { IconSave } from '../icons/Icons'

const ModalitiesForm = ({ idData }) => {
    const MySwal = withReactContent(Swal)
    const [formData, setFormData] = useState({ name: '' })
    const { getModality } = useModalities()

    useEffect(() => {
        getById(idData)
    }, [idData])

    const getById = async (id) => {
        if (id !== null) {
            const resp = await getModality(id)
            setFormData(() => (resp))
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(() => ({
            ...formData,
            [name]: value,
        }));
    }

    const handleSubmit = async (e) => {

    }
    return (

        <form onSubmit={handleSubmit}>
            <div className='grid grid-cols-1 gap-x-10 gap-y-2 mt-4 items-end'>
                <Input
                    textLabel={'Modalidad'}
                    typeInput={"text"}
                    name={"name"}
                    className='w-[75%]'
                    required={true}
                    value={formData.name}
                    onChange={handleInputChange}
                />
            </div>
            <div className="flex justify-between items-center gap-2 mt-6">
                <div className='flex flex-col gap-2'>
                    <span className='text-red-500 text-xs italic'>* Campos obligatorios</span>
                </div>
                <div className='flex gap-2 items-center'>
                    <ButtonPrimaryForm text={'Guardar'} typeBtn={'submit'} >
                        <IconSave className='w-4' />
                    </ButtonPrimaryForm>
                </div>
            </div>
        </form>

    )
}

export default ModalitiesForm